/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
export const tabsList = [
	{
		id: 1,
		tab: "description",
		name: "Описание системы и ее характеристика как объекта защиты",
		filled: "",
	},
	{
		id: 2,
		tab: "types_of_risks",
		name: "Виды рисков (ущерба) и негативные последствия",
		filled: "",
	},
	{
		id: 3,
		tab: "objects_of_impact",
		name: "Объекты воздействия и виды воздействия на них",
		filled: "",
	},
	{
		id: 4,
		tab: "collusion_groups",
		name: "Группы сговора",
		filled: "",
	},
	{
		id: 5,
		tab: "assessment_of_objectives",
		name: "Оценка целей реализации нарушителями угроз безопасности",
		filled: "",
	},
	{
		id: 6,
		tab: "levels_of_violators",
		name: "Уровни возможностей нарушителей по реализации угроз безопасности информации",
		filled: "",
	},
	{
		id: 7,
		tab: "current_violators",
		name: "Актуальные нарушители при реализации угроз безопасности",
		filled: "",
	},
	{
		id: 8,
		tab: "possible_objects",
		name: "Актуальные способы реализации угроз безопасности",
		filled: "",
	},
	{
		id: 9,
		tab: "list_of_basic",
		name: "Перечень основных тактик и соответствующих им типовых техник",
		filled: "",
	},
	{
		id: 10,
		tab: "list_current_threats",
		name: "Перечень актуальных угроз безопасности информации",
		filled: "",
	},
];
